import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TabComponent from './../batch-assignment/tab-component';
import UploadDispatch from './upload-dispatch';
import { ALL_TABS } from 'constants/workbook-management';
import memoize from 'memoize-one';
import styled from 'styled-components';

const Container = styled.div`
  width: inherit;
  height: inherit;
  margin: 0 auto;
`;

const { UPLOAD_DISPATCH } = ALL_TABS || {};

const TABS = [
  {
    id: UPLOAD_DISPATCH,
    label: UPLOAD_DISPATCH,
    Component: UploadDispatch,
  },
];

const getTabs = memoize(tabs =>
  tabs.map(tab => ({
    ...tab,
    link: `/workbook-management/${tab.id}`,
  })),
);

class WorkbookManagement extends PureComponent {
  static defaultProps = {
    match: null,
  };

  static propTypes = {
    match: PropTypes.shape({}),
  };

  render() {
    const {
      match: {
        params: { activeTab },
      },
    } = this.props;
    const tabs = getTabs(TABS);

    return (
      <Container>
        <TabComponent tabs={tabs} activeTab={activeTab} />
      </Container>
    );
  }
}

export default WorkbookManagement;
